/**
 * ControlStrip + TextInput + SelectControl (P27).
 *
 * Lifted verbatim from `sample-wireframe/client/src/pages/Home.tsx`.
 * `.control-strip` / `.search-control` / `.select-control` classes live in
 * the lifted CSS. Default search/env/risk filter set is preserved; callers
 * pass `<SelectControl>`/`<ActionButton>` children for per-page additions.
 */
import type { JSX, ReactNode } from 'react';
import { Filter, Search } from 'lucide-react';

import { ActionButton } from './ActionButton.js';

export function TextInput({ placeholder = 'Search' }: { placeholder?: string }): JSX.Element {
  return (
    <label className="search-control">
      <Search size={15} aria-hidden />
      <input placeholder={placeholder} aria-label={placeholder} />
    </label>
  );
}

interface SelectControlProps {
  label: string;
  options: readonly string[];
}

export function SelectControl({ label, options }: SelectControlProps): JSX.Element {
  return (
    <label className="select-control">
      <span>{label}</span>
      <select defaultValue={options[0]} aria-label={label}>
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    </label>
  );
}

export function ControlStrip({ children }: { children?: ReactNode }): JSX.Element {
  return (
    <div className="control-strip">
      <TextInput placeholder="Search tools, sessions, users, policies..." />
      <SelectControl label="Environment" options={['Production', 'Staging', 'Sandbox']} />
      <SelectControl label="Risk" options={['All risk', 'Critical', 'High', 'Medium', 'Low']} />
      <ActionButton icon={Filter}>More filters</ActionButton>
      {children}
    </div>
  );
}
